//
// Formularüberprüfungen
//

function init() {
    const inputElements = document.querySelectorAll('.form-has-file + input');

    inputElements.forEach(function (element) {
      element.required = false;
    });
}

export default {};

export const Init = init;
